import config from "../config";
import { ListActionProvider } from "@beeldit/core/actions/list/ListActionContext";
import { RemoveActionProvider } from "@beeldit/core/actions/remove/RemoveActionContext";
import { CreateActionProvider } from "@beeldit/core/actions/create/CreateActionContext";
import { DetailsActionProvider } from "@beeldit/core/actions/details/DetailsActionContext";
import TableWithDetailsPage from "@beeldit/core/pages/TableWithDetailsPage";
import TablePage from "@beeldit/core/pages/TablePage";

function CustomerNotesPage(props: {
  filters?: any;
  formDefaultValues?: any;
}) {

  const { filters, formDefaultValues } = props;

  const tablePageParams = {
    modelConfig: config, // Configuración del modelo
    formDefaultValues: formDefaultValues || null, // Valores por defecto del formulario
    filters: filters || null, // Filtros para la tabla
    formFilterValues: null,
  };

  return (
    <ListActionProvider key={config.modelName}>
      <RemoveActionProvider>
        <CreateActionProvider>
        <DetailsActionProvider>
          <>
            <TablePage
              {...tablePageParams}
            />
            </>
        </DetailsActionProvider>
        </CreateActionProvider>
      </RemoveActionProvider>
    </ListActionProvider>
  );
}

export default CustomerNotesPage;
